import { Injectable } from '@angular/core';
import { resolveApiBaseUrl } from '../_helpers/api-base-url';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';

export interface AppConfig {
  mapTilerKey: string;
  amplitudeApiKey: string;
  analyticsUrl: string;
  emsAnalyticsUrl: string;
  errorLogUrl: string;
}

/**
 * Non-secret client config (analytics URLs, MapTiler/Amplitude keys) fetched from an
 * authenticated backend endpoint after login. AWS credentials are deliberately NOT
 * included here: file storage goes through backend-issued pre-signed URLs
 * (see S3StorageService / S3ProfileStorageService), so the browser never holds them.
 * AuthGuard awaits `ensureLoaded()` before activating any guarded route, so consumers
 * under `pages/*` can read `.config` directly once past the guard.
 */
@Injectable({ providedIn: 'root' })
export class AppConfigService {
  config: AppConfig | null = null;

  constructor(private http: HttpClient) {}

  /** Fetches config if not already loaded; safe to call repeatedly. Never throws on failure. */
  async ensureLoaded(): Promise<void> {
    if (this.config) {
      return;
    }
    try {
      this.config = await firstValueFrom(
        this.http.get<AppConfig>(`${resolveApiBaseUrl('api/voyage')}/api/voyage/ClientKeys`)
      );
    } catch {
      // config stays null; consumers must handle that until the backend call succeeds
    }
  }
}
